import type { FilterFn } from '@tanstack/react-table';

import { CooperativeCommonCase } from '../../models/types';

type TypedFilterFn = FilterFn<CooperativeCommonCase>;

export const filterCaseLevel1: TypedFilterFn = (row, _columnId, value) => {
  if (Array.isArray(value) && value.length) {
    return value.includes(row.original.CaseLevel1?.Value);
  }

  return false;
};

export const filterStatus: TypedFilterFn = (row, _columnId, value) => {
  if (Array.isArray(value) && value.length) {
    return value.includes(row.original.Status?.Value);
  }

  return false;
};

export const filterYear: TypedFilterFn = (row, _columnId, value) => {
  if (Array.isArray(value) && value.length) {
    const originalValue = row.original.CreatedOn;
    const year =
      typeof originalValue === 'string'
        ? new Date(originalValue).getFullYear()
        : null;
    return value.includes(year);
  }

  return false;
};
